/**
 * Konfigurations-Telemetrie (Feature 10)
 * Sendet Konfig-Snapshot an Backend für Auswertung (Gerätetypen, Browser, Abweichungen).
 * Opt-Out über telemetry_enabled in Konfiguration.
 */

import { FRONTEND_VERSION } from '../config/version';
import { getDeviceId, getDeviceName } from './deviceId';

/**
 * Ermittelt Gerätetyp aus Bildschirmbreite
 */
function getDeviceType() {
  if (typeof window === 'undefined' || !window.screen) return 'unknown';
  const w = window.screen.width;
  if (w < 768) return 'mobile';
  if (w < 1024) return 'tablet';
  return 'desktop';
}

/**
 * Vereinfachte Browser-Erkennung aus User-Agent
 */
function getBrowserInfo() {
  if (typeof navigator === 'undefined' || !navigator.userAgent) return { browser: 'unknown', version: null };
  const ua = navigator.userAgent;
  let browser = 'unknown';
  let version = null;
  const match = ua.match(/(Chrome|Safari|Firefox|Edge|Edg|MSIE|Trident)\/(\d+)/i);
  if (match) {
    browser = match[1].replace('Edg', 'Edge').replace(/Trident|MSIE/, 'IE');
    version = match[2];
  }
  return { browser: `${browser} ${version || ''}`.trim(), version: version };
}

/**
 * Sendet Konfig-Snapshot an Backend.
 * @param {Object} opts
 * @param {string} opts.backendUrl - Backend-URL (z.B. https://api.example.com)
 * @param {string|null} opts.licenseKey - Lizenzschlüssel (optional)
 * @param {number|null} opts.userId - User-ID (optional)
 * @param {Object} opts.config - Konfig-Snapshot (nur nicht-sensitive Keys)
 * @returns {Promise<boolean>} true bei Erfolg
 */
export async function sendConfigTelemetry({ backendUrl, licenseKey, userId, config }) {
  if (!backendUrl || !backendUrl.trim()) return false;
  const url = `${backendUrl.replace(/\/$/, '')}/api/telemetry/config`;
  const { browser, version } = getBrowserInfo();
  const payload = {
    user_id: userId ?? null,
    license_key: licenseKey ?? null,
    device_id: getDeviceId(),
    device_name: getDeviceName(),
    browser,
    browser_version: version,
    device_type: getDeviceType(),
    screen_width: typeof window !== 'undefined' && window.screen ? window.screen.width : null,
    screen_height: typeof window !== 'undefined' && window.screen ? window.screen.height : null,
    frontend_version: FRONTEND_VERSION,
    config: config || {},
  };
  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    if (!res.ok) {
      console.warn('[Telemetry] POST fehlgeschlagen:', res.status, res.statusText, url);
    }
    return res.ok;
  } catch (err) {
    console.warn('[Telemetry] Senden fehlgeschlagen:', err.message);
    return false;
  }
}
